// extracted by mini-css-extract-plugin
export default {"root":"_3BWcO","icon":"za9W2","active-icon":"_1Rv7b","activeIcon":"_1Rv7b"};